export default __webpack_public_path__ + "static/media/zoom-icon.1a4b07ad.png";